module.exports = {"210111001":"解放街道","210111003":"民主街道","210111005":"中兴街道","210111009":"林盛街道","210111010":"沙河街道","210111011":"十里河街道","210111012":"陈相街道","210111015":"永乐街道","210111018":"佟沟街道","210111019":"八一红菱街道","210111020":"沈水街道","210111021":"白清姚千街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210111.json
// module id = 593
// module chunks = 0